import { set } from 'app/util/set';
import { isHexadecimalValue, themeInitialValue, themes } from 'app/util/theme';
import { DefaultTheme } from 'styled-components';

export const useTheme = (): DefaultTheme => {
  const { theme: themeName } = { theme: 'default' };
  const theme: any = { ...themeInitialValue };

  const primaryColorRequested = themes.default;
  const primaryColor: string =
    primaryColorRequested && isHexadecimalValue(primaryColorRequested)
      ? primaryColorRequested
      : themes[themeName] ?? themes.default;

  set(theme, 'colors.primary', primaryColor);

  return theme;
};
